import React from "react";
import "./registrationForm.css";
import { DefaultButton } from "@fluentui/react";
import { Label } from "@fluentui/react/lib/Label";
import { TextField } from "@fluentui/react/lib/TextField";
import { useMutation } from "react-query";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SpinningLoader from "../Loaders/SpinningLoader";

const registerEmployee = async (data) => {
  const { data: response } = await axios.post(
    "https://mgt4g63xtf.execute-api.us-east-2.amazonaws.com/Prod/",
    data,
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data;
};




const RegisterForm = () => {
  const navigate = useNavigate();

  const [fname, setFname] = React.useState("");
  const [lname, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [contact, setContact] = React.useState("");

  const { mutate, isLoading } = useMutation(registerEmployee, {
    onSuccess: () => {
      alert("Employee registered successfully!");
      handleFormClear();
    },
    onError: (error) => {
      alert(error?.message);
    },
  });

  const handleEmployeeRegistration = (event) => {
    event.preventDefault();
    if (!fname || !lname || !email || !company || !contact) {
      alert("All fields are required !");
      return;
    }
    let dataBody = {
      email: email,
      firstName: fname,
      lastName: lname,
      companyName: company,
      contactNumber: contact,
    };
    mutate(dataBody);
  };
const goBack = () => {
        //navigate('https://www.unigenioussoft.com/');
	window.location.href='https://www.unigenioussoft.com/';
};


  const handleFormClear = () => {
    setFname("");
    setLastName("");
    setEmail("");
    setCompany("");
    setContact("");
  };

  return (
    <>
      <div className="main1">
        <div className="page-label">
          <h1>New Employee / Freelancer SignUp</h1>
        </div>

        <form className="form" id="id-employee-register">
          <div className="field">
            <Label htmlFor="First Name:" className="form-label">
              First Name:
            </Label>
            <TextField
              type="text"
              className="form-control"
              id="exampleFormControlInput1"
              value={fname}
              onChange={(e) => setFname(e.target.value)}
            />
          </div>
          <div className="field">
            <Label htmlFor="First Name:" className="form-label">
              Last Name:&nbsp; &nbsp;
            </Label>
            <TextField
              type="text"
              className="form-control"
              id="exampleFormControlInput1"
              value={lname}
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          <div className="field">
            <Label htmlFor="exampleFormControlInput1" className="form-label">
              Email / Login Id: &nbsp;&nbsp;&nbsp;
            </Label>
            <TextField
              type="email"
              className="form-control"
              id="exampleFormControlInput1"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="field">
            <Label htmlFor="exampleFormControlTextarea1" className="form-label">
              Company Name / Independent:
            </Label>
            <TextField
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
            ></TextField>
          </div>

          <div className="field">
            <Label htmlFor="exampleFormControlInput1" className="form-label">
              Contact Number: &nbsp;&nbsp;
            </Label>
            <TextField
              type="number"
              className="form-control"
              id="exampleFormControlInput1"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
            />
          </div>

          <div className="field">
            <div className="btn overflow-button">
	     <DefaultButton
                className="btnBack"
                disabled={isLoading}
                onClick={(e) => goBack(e)}
              >
                {isLoading ? "please wait" : "Home"}
              </DefaultButton>

              <DefaultButton
                className="btnSave"
                disabled={isLoading}
                onClick={(e) => handleEmployeeRegistration(e)}
              >
                {isLoading ? "please wait" : "Save"}
              </DefaultButton>
              <DefaultButton className="btnClear" onClick={handleFormClear}>
                Clear
              </DefaultButton>
              <DefaultButton
                className="btnLogin"
                onClick={() => navigate("/login")}
              >
                Login
              </DefaultButton>
            </div>
          </div>
        </form>
        <SpinningLoader isLoading={isLoading} />
      </div>
    </>
  );
};
export default RegisterForm;
